var X_RATELIMIT_RESET = 'x-ratelimit-reset';
/**
 * If response has x-ratelimit-reset header (time till next allowed request),
 * then return its value.
 *
 * @param  {Object} response - HTTP response
 * @return {Object} - rateLimitResetTime or empty object
 */

export default function getRateLimit(response) {
  var rateLimitResetTime = response.headers.get(X_RATELIMIT_RESET);

  if (rateLimitResetTime) {
    return {
      rateLimitResetTime: Number(rateLimitResetTime)
    };
  }

  return {};
}
/**
* @param  {Object} response - HTTP response
* @return {Boolean} - presence of x-ratelimit-reset header in response
*/

export function hasRateLimitHeader(response) {
  return !!response.headers.get(X_RATELIMIT_RESET);
}